import {
  HttpClient,
  HttpHeaders,
  HttpQueryParameters,
  HttpRequestMethod,
  RequestOptions,
} from "@rumble-it/common-lib/src/api/httpClient";
import { User } from "oidc-client-ts";
import { getConfigValue } from "@rumble-it/common-lib/src/config";

export const fetchData = async ({
  endpoint,
  queryParameters,
  data,
  headers,
  method = "GET",
  returnResponse = false,
}: {
  endpoint: string;
  queryParameters?: HttpQueryParameters;
  data?: any;
  headers?: HttpHeaders;
  method?: HttpRequestMethod;
  returnResponse?: boolean;
}) => {
  const oidcStorage = sessionStorage.getItem(
    `oidc.user:${getConfigValue("authUrl")}/realms/${getConfigValue("authRealm")}:${getConfigValue("authClientId")}`,
  );

  if (!oidcStorage) {
    throw new Error("OIDC user not found in session storage.");
  }

  const user = User.fromStorageString(oidcStorage);

  const affiliateStorage = sessionStorage.getItem(
    `api.user.affiliate:${user?.profile?.sub}`,
  );

  if (!affiliateStorage) {
    throw new Error("Affiliate ID not found in session storage.");
  }

  const affiliateId = affiliateStorage;

  const accessToken = user?.access_token || null;

  /**
   * Create a new instance of the HttpClient with the affiliate ID and token.
   */
  const httpClient = new HttpClient({
    affiliateId,
  }).setBearerToken(accessToken);

  /**
   * Set the request options
   */
  const options: RequestOptions = {};
  if (queryParameters) options.params = queryParameters;
  if (headers) options.headers = headers;
  if (data) options.data = data;

  /**
   * Make the request
   */
  try {
    const response = await httpClient.request(
      method,
      endpoint.startsWith("/") ? endpoint : "/" + endpoint,
      options,
    );

    if (returnResponse === true) {
      return response;
    }

    if (response.data) {
      let data = response.data;

      if (data["@type"] === "Collection" && Array.isArray(data["member"])) {
        data = data["member"];
      }

      return {
        data,
      };
    } else {
      return null;
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
};
